import { useState, useCallback, useEffect } from "react";
import { useAuthedRequest } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";
import { RequestCache } from "shared/@hooks/useRequestCache";

export function useLocalFunctions({ iboNumber, page = 0, limit = 25 }) {
  const { logError } = useLogger({ prefix: "useLocalFunctions" });
  const [requestId, setRequestId] = useState(0);
  const [records, setRecords] = useState(null);
  const [paging, setPaging] = useState(null);
  const cache = RequestCache.useContainer();
  const { data, loading, error } = useAuthedRequest(
    `/v1/membership/transactions/${iboNumber}/localfunctions/?limit=${limit}&page=${page}&req=${requestId}`,
    null,
    cache
  );

  // Prevent records from becoming null between refreshes.
  useEffect(() => {
    if (data != null) {
      setRecords(data.data);
      setPaging(data.paging);
    }
  }, [data]);

  const refresh = useCallback(() => {
    setRequestId(requestId + 1);
  }, [requestId]);

  return {
    records,
    paging,
    loading,
    refresh,
  };
}
